import { RSAA } from 'redux-api-middleware';
import fetch from 'isomorphic-fetch';
import { browserHistory } from 'react-router';

import api from '../../api';

import { ADD_TO_CART_SUCCESS, getCartTotal } from './cart';
import { CLOSE_ADDED_TO_CART } from './addedToCart';

// ------------------------------------
// Constants
// ------------------------------------
const SET_COUPON = 'farmakom/checkout/SET_COUPON';
const RESET_COUPON = 'farmakom/checkout/RESET_COUPON';

const SET_PAYMENT_TYPE = 'farmakom/checkout/SET_PAYMENT_TYPE';
const SAVE_SHIPPING = 'farmakom/checkout/SAVE_SHIPPING';
const SAVE_RICETTA = 'farmakom/checkout/SAVE_RICETTA';

const GET_COUPON_REQUEST = 'farmakom/checkout/GET_COUPON_REQUEST';
const GET_COUPON_SUCCESS = 'farmakom/checkout/GET_COUPON_SUCCESS';
const GET_COUPON_FAILURE = 'farmakom/checkout/GET_COUPON_FAILURE';

const GET_ENABLED_CITIES_REQUEST =
  'farmakom/checkout/GET_ENABLED_CITIES_REQUEST';
const GET_ENABLED_CITIES_SUCCESS =
  'farmakom/checkout/GET_ENABLED_CITIES_SUCCESS';
const GET_ENABLED_CITIES_FAILURE =
  'farmakom/checkout/GET_ENABLED_CITIES_FAILURE';

const GET_SHIPPING_COST_REQUEST = 'farmakom/checkout/GET_SHIPPING_COST_REQUEST';
const GET_SHIPPING_COST_SUCCESS = 'farmakom/checkout/GET_SHIPPING_COST_SUCCESS';
const GET_SHIPPING_COST_FAILURE = 'farmakom/checkout/GET_SHIPPING_COST_FAILURE';

const CREATE_ORDER_REQUEST = 'farmakom/checkout/CREATE_ORDER_REQUEST';
const CREATE_ORDER_SUCCESS = 'farmakom/checkout/CREATE_ORDER_SUCCESS';
const CREATE_ORDER_FAILURE = 'farmakom/checkout/CREATE_ORDER_FAILURE';
export const CREATE_ORDER_NOT_AVAILABLE =
  'farmakom/checkout/CREATE_ORDER_NOT_AVAILABLE';

const RESET_CHECKOUT = 'farmakom/checkout/RESET_CHECKOUT';
export const SET_GUEST_CHECKOUT = 'farmakom/checkout/SET_GUEST_CHECKOUT';

const SAVE_SOURCE_MEDIUM_SUCCESS =
  'farmakom/checkout/SAVE_SOURCE_MEDIUM_SUCCESS';

// ------------------------------------
// Actions
// ------------------------------------

export function setCoupon(couponCode) {
  return {
    type: SET_COUPON,
    payload: couponCode,
  };
}

export function setPaymentType(paymentType, paymentCost) {
  return {
    type: SET_PAYMENT_TYPE,
    payload: { paymentType, paymentCost: paymentCost || 0 },
  };
}

export function saveShipping(shippingData) {
  return {
    type: SAVE_SHIPPING,
    payload: shippingData,
  };
}

export function saveRicetta(ricettaData) {
  return {
    type: SAVE_RICETTA,
    payload: ricettaData,
  };
}

export function setGuestCheckout(guestCheckout) {
  return {
    type: SET_GUEST_CHECKOUT,
    payload: guestCheckout,
  };
}

// API CALL
export function getCoupon(couponCode) {
  const cartId = localStorage.getItem('cartId');
  if (!cartId || !couponCode) {
    return function(dispatch) {
      dispatch({
        type: GET_COUPON_FAILURE,
        payload: 'Cart id o coupon code non presenti',
      });
    };
  } else {
    return function(dispatch, getState) {
      const { endpoint, method, headers } = api.getCoupon(couponCode, cartId);
      const storeid = getState().store.data.storeId;
      const headersWithStoreId = {
        ...headers,
        storeid,
      };
      dispatch({ type: GET_COUPON_REQUEST });
      fetch(endpoint, { method, headers: headersWithStoreId })
        .then(response => {
          if (response.ok) {
            // Response OK => JSON
            return response.json();
          }
          dispatch({
            type: GET_COUPON_FAILURE,
            payload: 'Errore generico caricando il coupon',
          });
        })
        .then(data => {
          // Here I have the JSON data
          dispatch({
            type: GET_COUPON_SUCCESS,
            payload: data,
          });
          const cart = getState().cart;
          if (
            data.products &&
            !!cart.length &&
            cart.length !== data.products.length
          ) {
            const missing = data.products.find(
              product => !cart.find(prod => prod.id === product.id)
            );
            if (missing) {
              dispatch({
                type: ADD_TO_CART_SUCCESS,
                payload: {
                  product: missing,
                  quantity: 1,
                  image: missing.image,
                },
              });
              setTimeout(() => {
                dispatch({
                  type: CLOSE_ADDED_TO_CART,
                });
              }, 3000);
            }
          }
        })
        .catch(error => {
          dispatch({
            type: GET_COUPON_FAILURE,
            payload: error,
          });
        });
    };
  }
}

// API CALL
export function getShippingCost(cartId, zipcode, country) {
  return {
    [RSAA]: {
      ...api.getShippingCost(cartId, zipcode, country),
      types: [
        GET_SHIPPING_COST_REQUEST,
        GET_SHIPPING_COST_SUCCESS,
        GET_SHIPPING_COST_FAILURE,
      ],
    },
  };
}

// THUNK
export function createOrder(order) {
  let firstProductId = null;

  if (!!sessionStorage) {
    const sessionStorageFirstProductId = sessionStorage.getItem(
      'firstProductId'
    );
    if (
      sessionStorageFirstProductId &&
      sessionStorageFirstProductId !== 'undefined'
    ) {
      firstProductId = sessionStorageFirstProductId;
    }
  }

  let orderToSend = {
    cartId: order.cartId,
    shipping: order.shipping,
    billing: order.billing,
    couponCode: order.coupon.code,
    paymentType: order.paymentType,
    shippingType: order.shippingType,
    slotHour: order.slotHour,
    isInvoiceRequested: !!order.isInvoiceRequested,
    pickupAtPharmacy: !!order.pickupAtPharmacy,
    ricetta: order.ricetta,
    medium: order.medium || null,
    source: order.source || null,
    firstProductId,
  };

  if (order.guestCheckout) {
    orderToSend = {
      ...orderToSend,
      user: order.user,
    };
  }

  // if (!!order.pickupLocation && order.pickupLocation.id !== 'store_address') {
  if (!!order.pickupLocation) {
    orderToSend.pickupLocation = order.pickupLocation;
    delete orderToSend.pickupLocation.id;
    delete orderToSend.pickupLocation.storeId;
    delete orderToSend.pickupLocation.createdAt;
  }

  delete orderToSend.pudo;

  return function(dispatch, getState) {
    const { endpoint, method, headers, body } = api.createOrder(
      orderToSend,
      order.guestCheckout
    );
    const storeid = getState().store.data.storeId;

    const headersWithStoreId = {
      ...headers,
      storeid,
    };

    dispatch({ type: CREATE_ORDER_REQUEST, payload: orderToSend });

    fetch(endpoint, { method, headers: headersWithStoreId, body })
      .then(response => {
        if (response.ok) {
          // Response OK => JSON
          return response.json();
        }

        dispatch({
          type: CREATE_ORDER_FAILURE,
        });
        browserHistory.push('/checkout-failure');
        throw new Error('Risposta da server non OK su creazione pagamento');
      })
      .then(data => {
        // Here I have the JSON data

        // CONTROLLO DISPONIBILITA'
        // Per LaFarmaceutica
        if (data.availability) {
          // Qualche articolo non è disponibile
          dispatch({
            type: CREATE_ORDER_NOT_AVAILABLE,
            payload: data.availability,
          });
          browserHistory.push('/carrello?na=1');
        } else {
          // Tutto è disponibile
          // o non viene effettuato il controllo
          dispatch({
            type: CREATE_ORDER_SUCCESS,
            payload: data,
          });

          if (
            order.paymentType === 'credit_card' ||
            order.paymentType === 'nexi' ||
            order.paymentType === 'paypal' ||
            order.paymentType === 'satispay'
          ) {
            //sia ordine carta di credito sia satispay ho  url redirect => redirect
            if (data.redirectUrl && data.redirectUrl.indexOf('http') > -1) {
              // Ordine Carta di credito, ho l'URL di redirect => Redirect //OLD
              console.log(
                'Order Credit card OK, redirecting to',
                data.redirectUrl
              );
              if (window) {
                // Siamo su browser
                window.location = data.redirectUrl;
              }
            } else {
              // Ordine Carta di credito, ma server non mi ha dato URL di Redirect
              // => E' successo qualcosa di strano
              // Raven.captureMessage(
              //   JSON.stringify({ type: 'Creazione ordine fallito, manca URL redirect', orderToSend }),
              //   {
              //     level: 'error'
              //   });

              browserHistory.push('/checkout-failure');
              throw new Error('Pagamento Carta di credito senza redirectUrl');
            }
          } else {
            // Ordine Bonifico o Contrassegno salvato
            console.log('Ordine Bonifico o Contrassegno salvato');
            const url =
              '/checkout-success' +
              (order.user && order.user.email
                ? '/?userEmail=' + order.user.email
                : '');
            browserHistory.push(url);
          }
        }
      })
      .catch(error => {
        console.error(error);
        // Raven.captureMessage(
        //   JSON.stringify({ type: 'Errore durante salvataggio ordine - CATCH', orderToSend }),
        //   {
        //     level: 'error'
        //   });

        dispatch({
          type: CREATE_ORDER_FAILURE,
        });
        browserHistory.push('/checkout-failure');
      });
  };
}

export function getEnabledCities() {
  return function(dispatch, getState) {
    const { endpoint, method, headers } = api.getEnabledCities();
    const storeid = getState().store.data.storeId;

    const headersWithStoreId = {
      ...headers,
      storeid,
    };

    dispatch({ type: GET_ENABLED_CITIES_REQUEST });

    fetch(endpoint, { method, headers: headersWithStoreId })
      .then(response => {
        if (response.ok) {
          // Response OK => JSON
          return response.json();
        }
        dispatch({
          type: GET_ENABLED_CITIES_FAILURE,
        });
        throw new Error('Risposta da server non OK su get enabled cities');
      })
      .then(data => {
        // Here I have the JSON data
        dispatch({
          type: GET_ENABLED_CITIES_SUCCESS,
          payload: data,
        });
      })
      .catch(error => {
        dispatch({
          type: CREATE_ORDER_FAILURE,
          payload: error,
        });
      });
  };
}

export function geocodeAddress(address) {
  return function(dispatch, getState) {
    const { endpoint, method, headers } = api.geocodeAddress(address);
    const storeid = getState().store.data.storeId;

    const headersWithStoreId = {
      ...headers,
      storeid,
    };

    return fetch(endpoint, { method, headers: headersWithStoreId })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw Error('Response not ok geocoding address');
        }
      })
      .then(data => {
        // Here I have the JSON data
        return data;
      });
  };
}

export function resetCheckout() {
  return {
    type: RESET_CHECKOUT,
  };
}

export function resetCoupon() {
  return {
    type: RESET_COUPON,
  };
}

export function saveSourceMedium(sourceMedium) {
  return function(dispatch) {
    dispatch({
      type: SAVE_SOURCE_MEDIUM_SUCCESS,
      payload: sourceMedium,
    });
  };
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialCoupon = {
  code: '',
  discount: 0,
  minAmount: 0,
  loading: false,
  error: '',
};

const initialState = {
  loading: false,
  error: '',
  guestCheckout: false,
  coupon: initialCoupon,
  shipping: {
    useDefault: 'true',
  },
  billing: {
    useDefault: 'true',
    isCompany: 'false',
  },
  // paymentType: 'credit_card',
  shippingCost: 0,
  shippingSurcharge: 0,
  paymentCost: 0,
  doneShipping: false,
  doneRicetta: false,
  availability: [],
  ricetta: {},
  loadingCities: false,
  errorCities: false,
  enabledCities: [],
  pickupAtFarmacy: 0,
  medium: '',
  source: '',
};

export default function checkoutReducer(state = initialState, action) {
  switch (action.type) {
    case SET_COUPON:
      return {
        ...state,
        coupon: {
          ...state.coupon,
          code: action.payload,
        },
      };
    case RESET_COUPON:
      return {
        ...state,
        coupon: initialCoupon,
      };
    case SET_GUEST_CHECKOUT:
      return {
        ...state,
        guestCheckout: action.payload,
      };
    case SET_PAYMENT_TYPE:
      return {
        ...state,
        paymentType: action.payload.paymentType,
        paymentCost: action.payload.paymentCost,
      };
    case SAVE_SHIPPING:
      return {
        ...state,
        ...action.payload,
        doneShipping: true,
      };
    case SAVE_RICETTA:
      return {
        ...state,
        ...action.payload,
        doneRicetta: true,
      };
    case GET_COUPON_REQUEST:
      return {
        ...state,
        coupon: {
          ...state.coupon,
          loading: true,
        },
      };
    case GET_COUPON_SUCCESS:
      return {
        ...state,
        coupon: {
          ...initialCoupon, // azzero tutto
          ...action.payload, // sovrascrivo con coupon ricevuto
          code: state.coupon.code, // riscrivo codice perché su errore torna ""
          loading: false,
          error: '',
        },
      };
    case GET_COUPON_FAILURE:
      return {
        ...state,
        loading: false,
        coupon: {
          ...initialCoupon,
          loading: false,
          error: action.payload.message,
        },
      };
    case GET_SHIPPING_COST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_SHIPPING_COST_SUCCESS:
      return {
        ...state,
        loading: false,
        shippingCost: action.payload.shippingCost,
        brtFastShippingCost: action.payload.brtFastShippingCost,
        brtPudoShippingCost: action.payload.brtPudoShippingCost || 0,
        // fastShippingCost: action.payload.fastShippingCost,
        // slotShippingCost: action.payload.slotShippingCost,
        shippingSurcharge: action.payload.shippingSurcharge,
        shippingAbroadThreshold: action.payload.shippingAbroadThreshold,
        pickupAtFarmacy: action.payload.pickupAtFarmacy,
        error: null,
      };
    case GET_SHIPPING_COST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case CREATE_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        orderId: action.payload.id,
        grandTotal: action.payload.grandTotal,
      };
    case CREATE_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        error: "Errore durante la creazione dell'ordine",
      };
    case CREATE_ORDER_NOT_AVAILABLE:
      return {
        ...state,
        availability: action.payload,
      };
    case RESET_CHECKOUT:
      return {
        ...initialState,
        medium: state.medium,
        source: state.source,
      };
    case GET_ENABLED_CITIES_REQUEST:
      return {
        ...state,
        loadingCities: true,
      };
    case GET_ENABLED_CITIES_SUCCESS:
      return {
        ...state,
        loadingCities: false,
        enabledCities: action.payload,
      };
    case GET_ENABLED_CITIES_FAILURE:
      return {
        ...state,
        loadingCities: false,
        errorCities: action.payload,
      };
    case SAVE_SOURCE_MEDIUM_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

// ------------------------------------
// Selectors
// ------------------------------------

export function isValidCoupon(globalState) {
  return (
    globalState.checkout.coupon.code.length > 2 &&
    !!globalState.checkout.coupon.discount &&
    getCartTotal(globalState) >= globalState.checkout.coupon.minAmount &&
    (globalState.store.data.funzionalita.couponIsAppliedToSopOtc ||
      !globalState.cart.every(
        product =>
          product.type === 'farmaci' || product.taxCreditType === 'DRUG'
      ))
  );
}
